<a class="skip-to-content" href="#main-content">Skip to content</a>
<mat-toolbar class="app-toolbar" role="banner">
    <button type="button" mat-icon-button (click)="sidenav.toggle()" aria-label="Toggle navigation menu">
        <mat-icon>menu</mat-icon>
    </button>
    <span class="toolbar-title" (click)="onTitleClick()">NW Hub</span>
    <mat-icon *ngIf="features.labsMode()" class="labs-indicator" title="Labs mode active (click to disable)"
              (click)="features.setLabsMode(false)">science</mat-icon>
    <span class="toolbar-spacer"></span>
    <ng-container *ngIf="user.user() as currentUser; else loginBtn">
      <button mat-button [matMenuTriggerFor]="userMenu" class="toolbar-user-btn"
              [attr.aria-label]="'Account menu for ' + currentUser.user_displayname">
        <mat-icon>account_circle</mat-icon>
        <span class="toolbar-user-name">{{ currentUser.user_displayname }}</span>
      </button>
      <mat-menu #userMenu="matMenu">
        <a mat-menu-item routerLink="/account">
          <mat-icon>manage_accounts</mat-icon>
          <span>Account</span>
        </a>
        <a mat-menu-item routerLink="/shares">
          <mat-icon>share</mat-icon>
          <span>Shared builds</span>
        </a>
        <a mat-menu-item routerLink="/admin" *ngIf="currentUser.is_admin">
          <mat-icon>shield</mat-icon>
          <span>Admin</span>
        </a>
        <button mat-menu-item (click)="logout()">
          <mat-icon>logout</mat-icon>
          <span>Log out</span>
        </button>
      </mat-menu>
    </ng-container>
    <ng-template #loginBtn>
      <a mat-icon-button routerLink="/login" [queryParams]="{ returnUrl: router.url }"
         class="login-btn" title="Log in" aria-label="Log in">
        <mat-icon>login</mat-icon>
      </a>
    </ng-template>
    <button mat-icon-button (click)="openFeedback()" class="feedback-btn"
            title="Send feedback" aria-label="Send feedback">
      <mat-icon>feedback</mat-icon>
    </button>
    <button mat-icon-button (click)="theme.toggle()" class="theme-toggle-btn"
            [title]="theme.isDark ? 'Switch to light mode' : 'Switch to dark mode'"
            [attr.aria-label]="theme.isDark ? 'Switch to light mode' : 'Switch to dark mode'">
      <mat-icon>{{ theme.isDark ? 'light_mode' : 'dark_mode' }}</mat-icon>
    </button>
</mat-toolbar>

<mat-progress-bar *ngIf="loadingRoute()" class="route-loading-bar" mode="indeterminate"
                  aria-label="Loading page"></mat-progress-bar>

<mat-sidenav-container class="sidenav-container">
    <mat-sidenav #sidenav [mode]="isMobile() ? 'over' : 'side'" [opened]="!isMobile()" [fixedInViewport]="true" role="navigation" aria-label="Main navigation">
        <div class="sidenav">
            <nav>
                <ul>
                    <li>
                        <a routerLink="/" routerLinkActive="sidenav-active-link"
                            [routerLinkActiveOptions]="{exact: true}">Home</a>
                    </li>
                </ul>
            </nav>
            <mat-accordion>

                <mat-expansion-panel class="navExpantion" routerLinkActive #rdiscords="routerLinkActive"
                    [expanded]="rdiscords.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Neverwinter Community</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/guilds" routerLinkActive="sidenav-active-link">Guild List</a>
                            </li>
                            <li>
                                <a routerLink="/news" routerLinkActive="sidenav-active-link">Game News</a>
                            </li>
                            <li>
                                <a routerLink="/discords" [routerLinkActiveOptions]="{exact: true}"
                                    routerLinkActive="sidenav-active-link">Discord List</a>
                            </li>
                            <li *ngIf="features.labsMode()">
                                <a routerLink="/discord-summaries"
                                    routerLinkActive="sidenav-active-link">Community Feedback Summary <mat-icon class="labs-inline">science</mat-icon></a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <mat-expansion-panel class="navExpantion" routerLinkActive #rrainer="routerLinkActive"
                    [expanded]="rrainer.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Rainer's Tools</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/rainer" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="sidenav-active-link">Main Tools page</a>
                            </li>
                            <li>
                                <a routerLink="/rainer/builds" routerLinkActive="sidenav-active-link">Build list</a>
                            </li>
                            <li>
                                <a routerLink="/rainer/contests" routerLinkActive="sidenav-active-link">Contests</a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <mat-expansion-panel class="navExpantion" routerLinkActive #rmechanics="routerLinkActive"
                    [expanded]="rmechanics.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Combat System</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/mechanics" [routerLinkActiveOptions]="{exact: true}"
                                    routerLinkActive="sidenav-active-link">Mechanics Main</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/general" routerLinkActive="sidenav-active-link">General &amp; Intro</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/stats" routerLinkActive="sidenav-active-link">Stats</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/statcalc" routerLinkActive="sidenav-active-link">Rating Calculator</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/damagemath" routerLinkActive="sidenav-active-link">Damage Formula</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/healingmath" routerLinkActive="sidenav-active-link">Healing Formula</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/ehpmath" routerLinkActive="sidenav-active-link">Effective HP Formula</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/damagecalc" routerLinkActive="sidenav-active-link">Damage Calculator</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/healingcalc" routerLinkActive="sidenav-active-link">Healing Calculator</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/ehpcalc" routerLinkActive="sidenav-active-link">EHP Calculator</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/power" routerLinkActive="sidenav-active-link">Power</a>
                            </li>
                            <li>
                                <a routerLink="/mechanics/recovery" routerLinkActive="sidenav-active-link">Recharge Speed</a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <!-- Simulator group -->
                <mat-expansion-panel class="navExpantion" routerLinkActive #rsim="routerLinkActive"
                    [expanded]="rsim.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Simulator</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/characters" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="sidenav-active-link">Characters</a>
                            </li>
                            <li *ngIf="features.labsMode()">
                                <a routerLink="/sim" routerLinkActive="sidenav-active-link">Rotation Simulator <mat-icon class="labs-inline">science</mat-icon></a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <mat-expansion-panel class="navExpantion" routerLinkActive #rlogparser="routerLinkActive"
                    [expanded]="rlogparser.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Log Parser</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/logparser/how-to" routerLinkActive="sidenav-active-link">How to Get Logs</a>
                            </li>
                            <li>
                                <a routerLink="/logparser" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="sidenav-active-link">Combat Log Parser</a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <!-- Professions and Refining hidden for now -->

                <mat-expansion-panel class="navExpantion" routerLinkActive #requip="routerLinkActive"
                    [expanded]="requip.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Gear &amp; Equipment</mat-panel-title>
                    </mat-expansion-panel-header>
                    <mat-accordion class="nested-accordion">

                        <mat-expansion-panel class="navExpantion nested" routerLinkActive #rlgear="routerLinkActive"
                            [expanded]="rlgear.isActive">
                            <mat-expansion-panel-header>
                                <mat-panel-title>Gear</mat-panel-title>
                            </mat-expansion-panel-header>
                            <nav>
                                <ul>
                                    <li>
                                        <a routerLink="/gear" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="sidenav-active-link">Overview</a>
                                    </li>
                                    <li>
                                        <a routerLink="/gear/list" routerLinkActive="sidenav-active-link">Gear List</a>
                                    </li>
                                    <li>
                                        <a routerLink="/gear/companion" routerLinkActive="sidenav-active-link">Companion Gear</a>
                                    </li>
                                    <li>
                                        <a routerLink="/enchantments/list" routerLinkActive="sidenav-active-link">Enchantment List</a>
                                    </li>
                                    <li>
                                        <a routerLink="/artifacts/list" routerLinkActive="sidenav-active-link">Artifact List</a>
                                    </li>
                                    <li>
                                        <a routerLink="/consumables" routerLinkActive="sidenav-active-link">Consumables</a>
                                    </li>
                                </ul>
                            </nav>
                        </mat-expansion-panel>

                        <mat-expansion-panel class="navExpantion nested" routerLinkActive #rlcompanions="routerLinkActive"
                            [expanded]="rlcompanions.isActive">
                            <mat-expansion-panel-header>
                                <mat-panel-title>Companions</mat-panel-title>
                            </mat-expansion-panel-header>
                            <nav>
                                <ul>
                                    <li>
                                        <a routerLink="/companions" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="sidenav-active-link">Overview</a>
                                    </li>
                                    <li>
                                        <a routerLink="/companions/list" routerLinkActive="sidenav-active-link">Companion List</a>
                                    </li>
                                    <li>
                                        <a routerLink="/companions/powers" routerLinkActive="sidenav-active-link">Player Bonuses</a>
                                    </li>
                                    <li>
                                        <a routerLink="/companions/enhancements" routerLinkActive="sidenav-active-link">Enhancement Powers</a>
                                    </li>
                                    <li>
                                        <a routerLink="/companions/stable" routerLinkActive="sidenav-active-link">Stable Simulator</a>
                                    </li>
                                </ul>
                            </nav>
                        </mat-expansion-panel>

                        <mat-expansion-panel class="navExpantion nested" routerLinkActive #rmounts="routerLinkActive"
                            [expanded]="rmounts.isActive">
                            <mat-expansion-panel-header>
                                <mat-panel-title>Mounts &amp; Insignias</mat-panel-title>
                            </mat-expansion-panel-header>
                            <nav>
                                <ul>
                                    <li>
                                        <a routerLink="/mounts" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="sidenav-active-link">Overview</a>
                                    </li>
                                    <li>
                                        <a routerLink="/mounts/list" routerLinkActive="sidenav-active-link">Mount List</a>
                                    </li>
                                    <li>
                                        <a routerLink="/mounts/bonuses" routerLinkActive="sidenav-active-link">Insignia Bonuses</a>
                                    </li>
                                    <li>
                                        <a routerLink="/mounts/insignias" routerLinkActive="sidenav-active-link">Insignia Items</a>
                                    </li>
                                    <li>
                                        <a routerLink="/mounts/collars" routerLinkActive="sidenav-active-link">Collars</a>
                                    </li>
                                    <li>
                                        <a routerLink="/mounts/stable" routerLinkActive="sidenav-active-link">Stable Simulator</a>
                                    </li>
                                </ul>
                            </nav>
                        </mat-expansion-panel>

                    </mat-accordion>
                    <nav class="parent-level-link">
                        <ul>
                            <li>
                                <a routerLink="/upgrade-cost" routerLinkActive="sidenav-active-link">Upgrade Cost Calculator</a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <mat-expansion-panel class="navExpantion" routerLinkActive #rpacks="routerLinkActive"
                    [expanded]="rpacks.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Packs &amp; Lockboxes</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/packs" [routerLinkActiveOptions]="{exact: true}"
                                    routerLinkActive="sidenav-active-link">Lockboxes</a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <mat-expansion-panel class="navExpantion" routerLinkActive #rclasses="routerLinkActive"
                    [expanded]="rclasses.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Classes & Races</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/classes" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="sidenav-active-link">All Classes</a>
                            </li>
                            <li>
                                <a routerLink="/classes/races" routerLinkActive="sidenav-active-link">Races</a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <mat-expansion-panel class="navExpantion" routerLinkActive #rguildtools="routerLinkActive"
                    [expanded]="rguildtools.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Guild Tools</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/guild-tools/costs" routerLinkActive="sidenav-active-link">SH Costs</a>
                            </li>
                            <li>
                                <a routerLink="/guild-tools/log" routerLinkActive="sidenav-active-link">Guild Log</a>
                            </li>
                            <li>
                                <a routerLink="/guild-tools/roster" routerLinkActive="sidenav-active-link">Guild Roster</a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <mat-expansion-panel class="navExpantion" routerLinkActive #rotherinfo="routerLinkActive"
                    [expanded]="rotherinfo.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Other Info</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/other-info/aliases-and-binds" routerLinkActive="sidenav-active-link">Aliases &amp; Binds</a>
                            </li>
                            <li>
                                <a routerLink="/other-info/file-builder" routerLinkActive="sidenav-active-link">Alias/Bind File Builder</a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <mat-expansion-panel class="navExpantion" routerLinkActive #rexternal="routerLinkActive"
                    [expanded]="rexternal.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>External Tools &amp; Info</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/other-info/tools" routerLinkActive="sidenav-active-link">Tools</a>
                            </li>
                            <li>
                                <a routerLink="/other-info/misc" routerLinkActive="sidenav-active-link">Misc Links</a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

                <mat-expansion-panel class="navExpantion" routerLinkActive #roldjanne="routerLinkActive"
                    [expanded]="roldjanne.isActive">
                    <mat-expansion-panel-header>
                        <mat-panel-title>Old JanneNW Site</mat-panel-title>
                    </mat-expansion-panel-header>
                    <nav>
                        <ul>
                            <li>
                                <a routerLink="/old-janne/about" routerLinkActive="sidenav-active-link">About</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/disclaimer" routerLinkActive="sidenav-active-link">Disclaimer</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/basics/overview" routerLinkActive="sidenav-active-link">Overview</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/group-mechanics/scope" routerLinkActive="sidenav-active-link">Buffs &amp; Scope</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/group-mechanics/power-share" routerLinkActive="sidenav-active-link">Power Share</a>
                            </li>
                            <li class="nav-section-label">Legacy Resources</li>
                            <li>
                                <a routerLink="/old-janne/e-resources" routerLinkActive="sidenav-active-link"
                                    [routerLinkActiveOptions]="{exact: true}">General</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/e-resources/tr" routerLinkActive="sidenav-active-link">TR</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/e-resources/cw" routerLinkActive="sidenav-active-link">CW</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/e-resources/dc" routerLinkActive="sidenav-active-link">DC</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/e-resources/gf" routerLinkActive="sidenav-active-link">GF</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/e-resources/gwf" routerLinkActive="sidenav-active-link">GWF</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/e-resources/hr" routerLinkActive="sidenav-active-link">HR</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/e-resources/op" routerLinkActive="sidenav-active-link">OP</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/e-resources/sw" routerLinkActive="sidenav-active-link">SW</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/external-resources16" routerLinkActive="sidenav-active-link">Mod 16</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics19/stat-calc" routerLinkActive="sidenav-active-link">M19 Stat Calculator</a>
                            </li>
                            <li class="nav-section-label">Mechanics (Mod 16)</li>
                            <li>
                                <a routerLink="/old-janne/mechanics16/formulas" routerLinkActive="sidenav-active-link">M16 Formulas</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics16/stats" routerLinkActive="sidenav-active-link">M16 Stats &amp; Optimizer</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics16/power" routerLinkActive="sidenav-active-link">M16 Power</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics16/arp" routerLinkActive="sidenav-active-link">M16 Armor Pen</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics16/defense" routerLinkActive="sidenav-active-link">M16 Defense</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics16/accuracy" routerLinkActive="sidenav-active-link">M16 Accuracy</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics16/deflect" routerLinkActive="sidenav-active-link">M16 Deflect</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics16/severity" routerLinkActive="sidenav-active-link">M16 Severity</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics16/heals" routerLinkActive="sidenav-active-link">M16 Heals</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics16/calculators" routerLinkActive="sidenav-active-link">M16 Calculators</a>
                            </li>
                            <li class="nav-section-label">Mechanics (Legacy)</li>
                            <li>
                                <a routerLink="/old-janne/mechanics/damage" routerLinkActive="sidenav-active-link">Damage</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/diminishing" routerLinkActive="sidenav-active-link">Diminishing Returns</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/relative" routerLinkActive="sidenav-active-link">Relative Value</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/caps" routerLinkActive="sidenav-active-link">RI &amp; Caps</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/power" routerLinkActive="sidenav-active-link">Power</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/base" routerLinkActive="sidenav-active-link">Base Damage</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/ability" routerLinkActive="sidenav-active-link">Ability Scores</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/arp" routerLinkActive="sidenav-active-link">Armor Penetration</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/ca" routerLinkActive="sidenav-active-link">Combat Advantage</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/cs" routerLinkActive="sidenav-active-link">Critical Severity</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/chance" routerLinkActive="sidenav-active-link">Critical Chance</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/debuff" routerLinkActive="sidenav-active-link">Debuffs</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/recharge" routerLinkActive="sidenav-active-link">Recharge Speed</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/ap" routerLinkActive="sidenav-active-link">Action Points</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/defense" routerLinkActive="sidenav-active-link">Defense</a>
                            </li>
                            <li>
                                <a routerLink="/old-janne/mechanics/aggro" routerLinkActive="sidenav-active-link">Aggro</a>
                            </li>
                        </ul>
                    </nav>
                </mat-expansion-panel>

            </mat-accordion>
            <nav>
                <ul>
                    <li>
                        <a routerLink="/about" routerLinkActive="sidenav-active-link">About &amp; What's New</a>
                    </li>
                </ul>
            </nav>


        </div>
    </mat-sidenav>
    <mat-sidenav-content role="main" id="main-content">
        <router-outlet></router-outlet>
    </mat-sidenav-content>

</mat-sidenav-container>

<app-cookie-consent></app-cookie-consent>
